export default __webpack_public_path__ + "static/media/sim-san-remo.f6c699f9.jpg";